import type { CourseProgressResponse } from '@/application/dto/CourseProgressResponse';
import type { CourseProgress } from '@/domain/model/CourseProgress';

export const toCourseProgress = (response: CourseProgressResponse): CourseProgress => ({
  courseId: response.courseId,
  completed: response.completed,
  progressPercentage: response.progressPercentage,
  lastWatchedAt: response.lastWatchedAt,
});
